import React from 'react';
import {SvgIcon} from '../../icons/svgIcon';
import {Icons} from '../../icons/icons';
import {useTranslation} from 'react-i18next';
import {handleCopyOnClick} from './utils';

export type CopyMessageProps = {
    msg: string;
};

/**
 * Machine-readable marker for EU AI Act Article 50(2).
 * @see https://artificialintelligenceact.eu/article/50/
 */
const COPY_MACHINE_READABLE_PREFIX = '[AI-GENERATED-TEXT]\n';

export const CopyMessageButton = (props: CopyMessageProps) => {
    const {t} = useTranslation();
    const textToCopy = COPY_MACHINE_READABLE_PREFIX + t('assistant.copy-disclaimer') + '\n\n' + props.msg;
    return (
        <div className="copy-button">
            <button
                onClick={(event) => handleCopyOnClick(event, textToCopy, t('search.details.hibu-assistant.copied'))}>
                <SvgIcon icon={Icons.COPY} id="icon-settings" className="icon"/>
                <span>{t('search.details.hibu-assistant.copy')}</span>
            </button>
        </div>
    );
};
